import { render, staticRenderFns } from "./LeftBarCRM.vue?vue&type=template&id=1857304c&"
import script from "./LeftBarCRM.vue?vue&type=script&lang=js&"
export * from "./LeftBarCRM.vue?vue&type=script&lang=js&"
import style0 from "./LeftBarCRM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports